import React from "react";
import UploadImages from "../../../components/Dashboard/UploadImages";
import "./style.scss";
const UploadImagesPage = () => {
  return (
    <div className="upload_images_wrapper">
      <UploadImages />
    </div>
  );
};

export default UploadImagesPage;
